import { mergeAll } from "ramda"

export type Unit = {
    name: string
    symbol: string
}

export type UnitGroup = {
    name: string
    units: Record<string, Unit>
}

export const getAllUnits = () => flattenUnitGroups(unitGroups)

export const getUnit = (unitKey: string): Unit =>
    flattenUnitGroups(unitGroups)[unitKey] || {
        symbol: "",
        name: "",
    }

export const flattenUnitGroups = (unitGroups: UnitGroup[]) => mergeAll(unitGroups.map(g => g.units))

export const unitGroups: UnitGroup[] = [
    {
        name: "Time",
        units: {
            second: {
                name: "Second",
                symbol: "s",
            },
            minute: {
                name: "Minute",
                symbol: "min",
            },
            hour: {
                name: "Hour",
                symbol: "hr",
            },
            day: {
                name: "Day",
                symbol: "d",
            },
        },
    },
    {
        name: "Mass",
        units: {
            gram: {
                name: "Gram",
                symbol: "g",
            },
            kilogram: {
                name: "Kilogram",
                symbol: "kg",
            },
            ton: {
                name: "Ton",
                symbol: "t",
            },
            pound: {
                name: "Pound",
                symbol: "lb",
            },
        },
    },
    {
        name: "Volume",
        units: {
            milliliter: {
                name: "Milliliter",
                symbol: "mL",
            },
            liter: {
                name: "Liter",
                symbol: "L",
            },
            ounce: {
                name: "Ounce",
                symbol: "oz",
            },
            fluidOunce: {
                name: "Fluid Ounce",
                symbol: "fl oz",
            },
            cup: {
                name: "Cup",
                symbol: "c",
            },
            pint: {
                name: "Pint",
                symbol: "pt",
            },
            quart: {
                name: "Quart",
                symbol: "qt",
            },
            gallon: {
                name: "Gallon",
                symbol: "gal",
            },
        },
    },
    {
        name: "Length",
        units: {
            centimeter: {
                name: "Centimeter",
                symbol: "cm",
            },
            meter: {
                name: "Meter",
                symbol: "m",
            },
            kilometer: {
                name: "Kilometer",
                symbol: "km",
            },
            inch: {
                name: "Inch",
                symbol: "in",
            },
            feet: {
                name: "Feet",
                symbol: "ft",
            },
            yard: {
                name: "Yard",
                symbol: "yd",
            },
        },
    },
    {
        name: "Area",
        units: {
            squareCentimeter: {
                name: "Square Centimeter",
                symbol: "cm²",
            },
            squareMeter: {
                name: "Square Meter",
                symbol: "m²",
            },
            squareKilometer: {
                name: "Square Kilometer",
                symbol: "km²",
            },
            squareInch: {
                name: "Square Inch",
                symbol: "in²",
            },
            squareFeet: {
                name: "Square Feet",
                symbol: "ft²",
            },
        },
    },
    {
        name: "Catering",
        units: {
            person: {
                name: "Person",
                symbol: "person",
            },
            serving: {
                name: "Serving",
                symbol: "serving",
            },
            tray: {
                name: "Tray",
                symbol: "tray",
            },
            platter: {
                name: "Platter",
                symbol: "platter",
            },
            dozen: {
                name: "Dozen",
                symbol: "dozen",
            },
            halfTray: {
                name: "1/2 Tray",
                symbol: "1/2 tray",
            },
            package: {
                name: "Package",
                symbol: "package",
            },
            pan: {
                name: "Pan Serving",
                symbol: "pan",
            },
            batch: {
                name: "Batch",
                symbol: "batch",
            },
        },
    },
]
